export const setCanvasEvents = (eventService, canvasRef) => {

  const canvas = canvasRef.current;
  if (!canvas || !eventService) {
    return;
  }
  // mouse events
  canvas.addEventListener("mousedown", eventService.mouseDown);
  canvas.addEventListener("mousemove", eventService.mouseMove);
  canvas.addEventListener("mouseup", eventService.mouseUp);
  canvas.addEventListener("mouseleave", eventService.mouseLeave);
  canvas.addEventListener("mouseout", eventService.mouseLeave);

  if (isTouchDevice()) {

    //joystick events

    const joystickThumb = document.getElementById("joystick-thumb")
    if (joystickThumb) {
        joystickThumb.style.display = "block"
        const joystickBackground = document.getElementById("joystick-background")
        if (joystickBackground) joystickBackground.style.display = "block"
    
        joystickThumb.addEventListener("touchstart", eventService.joystickTouchStart)
        joystickThumb.addEventListener("touchmove", eventService.joystickTouchMove)
        joystickThumb.addEventListener("touchend", eventService.joystickTouchEnd)
        joystickThumb.addEventListener("touchcancel", eventService.joystickTouchEnd)
    }

    // canvas events
    canvas.addEventListener("touchstart", eventService.touchStart);
    canvas.addEventListener("touchmove", eventService.touchMove);
    canvas.addEventListener("touchend", eventService.touchEnd);
    canvas.addEventListener("touchcancel", eventService.touchEnd);
  }


  function isTouchDevice() {
    //@ts-ignore
    return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
  }
};



export const setWindowEvents = (eventService, canvasRef) => {
  if (!eventService) {
    return;
  }
  window.addEventListener("keydown", eventService.keyDownEvent);
  window.addEventListener("keyup", eventService.keyUpEvent);
  window.addEventListener("resize", eventService.onWindowResize, false);
};

export const removeEvents = (eventService, canvasRef) => {
  const canvas = canvasRef.current;
  if (!canvas || !eventService) {
    return;
  }

  window.removeEventListener("keydown", eventService.keyDownEvent);
  window.removeEventListener("keyup", eventService.keyUpEvent);
  window.removeEventListener("resize", eventService.onWindowResize, false);

  canvas.removeEventListener("mousedown", eventService.mouseDown);
  canvas.removeEventListener("mousemove", eventService.mouseMove);
  canvas.removeEventListener("mouseup", eventService.mouseUp);
  canvas.removeEventListener("mouseleave", eventService.mouseLeave);
  canvas.removeEventListener("mouseout", eventService.mouseLeave);
  
  const joystickThumb = document.getElementById("joystick-thumb")
  if (joystickThumb) {
    joystickThumb.removeEventListener("touchstart", eventService.joystickTouchStart)
    joystickThumb.removeEventListener("touchmove", eventService.joystickTouchMove)
    joystickThumb.removeEventListener("touchend", eventService.joystickTouchEnd)
    joystickThumb.removeEventListener("touchcancel", eventService.joystickTouchEnd)
  }

  canvas.removeEventListener("touchstart", eventService.touchStart);
  canvas.removeEventListener("touchmove", eventService.touchMove);
  canvas.removeEventListener("touchend", eventService.touchEnd);
  canvas.removeEventListener("touchcancel", eventService.touchEnd);
};

export const setEvents = (eventService, canvasRef) => {
  removeEvents(eventService, canvasRef);
  setWindowEvents(eventService, canvasRef);
  setCanvasEvents(eventService, canvasRef);
};
